import { kea } from 'kea'
import PropTypes from 'prop-types'

export default kea({
  initScene: {
    scene: 'how',

    reload: () => controller.index(),

    transform: payload => ({
      userType: payload.userType,
      howString: payload.howString,
      locationString: payload.locationString,
      tutoSlug: payload.tutoSlug
    })
  },

  path: () => ['scenes', 'how', 'index'],

  actions: () => ({
    setUserType: userType => ({ userType }),
    setSlideIndex: slideIndex => ({ slideIndex }),
    nextSlide: true,
    prevSlide: true
  }),

  actionToUrl: ({ actions, values }) => ({
    [actions.setUserType]: () => {
      const {
        howString,
        locationString,
        userType,
        tutoSlug: { for_students, for_teachers }
      } = values

      const urlSlug = userType === 'students' ? for_students : for_teachers
      return `/${howString}/${locationString}/${urlSlug}`
    }
  }),

  urlToAction: ({ actions, values }) => ({
    '/:howString/:locationString/:tutoSlug': ({ howString, locationString, tutoSlug }) => {
      const {
        howString: currentHowString,
        locationString: currentLocationString,
        userType,
        tutoSlug: { for_students, for_teachers }
      } = values
      console.log(userType)
      if (userType === 'teachers') {
        if (tutoSlug !== for_teachers || locationString !== currentLocationString) {
          actions.setUserType('students')
        }
      }

      if (userType === 'students') {
        if (tutoSlug !== for_students || locationString !== currentLocationString) {
          actions.setUserType('teachers')
        }
      }
    }
  }),

  reducers: ({ actions }) => ({
    userType: [
      'students',
      {
        [actions.setUserType]: (_, { userType }) => userType
      }
    ],
    howString: [null, {}],
    locationString: [null, {}],
    tutoSlug: [null, {}],
    slideIndex: [
      1,
      PropTypes.string,
      {
        [actions.setUserType]: _ => 1,
        [actions.setSlideIndex]: (_, { slideIndex }) => slideIndex,
        [actions.nextSlide]: currentSlideIndex => (currentSlideIndex === 4 ? 4 : currentSlideIndex + 1),
        [actions.prevSlide]: currentSlideIndex => (currentSlideIndex === 1 ? 1 : currentSlideIndex - 1)
      }
    ]
  })
})
